import { BENEFITS_DATA } from '@lib/data/teacher-lp'
import { FastlyImage } from '@components/common/image'

const IMAGE_PATH = '/images/teacher-lp/benefits/'

const Benefits = () => (
  <div className="relative">
    <div className="grid md:grid-cols-4 gap-4 md:gap-2 pt-16 px-4 container mx-auto">
      {BENEFITS_DATA.map((benefit) => (
        <div
          key={benefit.title}
          className="rounded-lg bg-white"
          style={{
            filter: 'drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1))',
          }}
        >
          <div className="p-8 md:px-6 md:py-10">
            <FastlyImage
              src={`${IMAGE_PATH}${benefit.icon}.png`}
              alt={`${benefit.title} icon`}
              height="90"
              width="80"
            />
            <p className="font-700 text-grey-900 text-2xl pt-6 md:pt-2 pb-3 leading-5">
              {benefit.title}
            </p>
            <p className="text-grey-800 text-xl md:text-lg leading-5">
              {benefit.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default Benefits
